import { render, staticRenderFns } from "./ListItemText.vue?vue&type=template&id=82d2fc50&scoped=true&"
import script from "./ListItemText.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ListItemText.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ListItemText.vue?vue&type=style&index=0&id=82d2fc50&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d2fc50",
  null
  
)

export default component.exports